import { render, staticRenderFns } from "./RenewalAirtime.vue?vue&type=template&id=19127ee2&scoped=true&"
import script from "./RenewalAirtime.vue?vue&type=script&lang=js&"
export * from "./RenewalAirtime.vue?vue&type=script&lang=js&"
import style0 from "./RenewalAirtime.vue?vue&type=style&index=0&id=19127ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19127ee2",
  null
  
)

export default component.exports